import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAuth, useMessage } from "@/contexts";
import { UserService } from "@/domains/user";
// components
import { Button, Form, Input } from "antd";

interface OperatorManageOptionsForm {
  password1: string;
  password2: string;
}

export const OperatorManageOptionsPage = () => {
  const { t } = useTranslation();

  const auth = useAuth();

  const [form] = Form.useForm<OperatorManageOptionsForm>();

  const { messageApi } = useMessage();

  const handleFinish = async (values: OperatorManageOptionsForm) => {
    if (!auth.user) return;

    try {
      await UserService.update(auth.user.id, {
        user: { password: values.password1 },
      }).run();

      form.resetFields();

      void messageApi.success(t("systems.Modal.updateSucceeded"));
    } catch (e) {
      console.log(e);
      void messageApi.success(t("systems.Modal.updateFailed"));
    }
  };

  useEffect(() => {
    form.resetFields();
    form.setFieldsValue({
      password1: "",
      password2: "",
    });
  }, [form]);

  return (
    <div className="w:500 p:16 bg:white r:4">
      <h4 className="mb:24 t:center fg:secondary">
        {t("domains.Setting.systemSetting")}
      </h4>

      <Form form={form} labelCol={{ span: 4 }} onFinish={handleFinish}>
        <Form.Item required label={t("domains.Setting.changePassword")}>
          <Form.Item
            name="password1"
            rules={[
              {
                required: true,
                message: t("systems.Error.cannotBeEmpty", {
                  field: t("domains.Setting.changePassword"),
                }),
              },
            ]}
          >
            <Input
              placeholder={t("systems.Placeholder.pleaseInput", {
                field: t("domains.Setting.changePassword"),
              })}
            />
          </Form.Item>

          <Form.Item
            name="password2"
            dependencies={["password1"]}
            rules={[
              {
                required: true,
                message: t("systems.Placeholder.pleaseInputAgain", {
                  field: t("domains.Setting.changePassword"),
                }),
              },
              {
                validator(_, value: string) {
                  if (value.length && value !== form.getFieldValue("password1"))
                    return Promise.reject(
                      t("systems.Error.confirmPasswordNotMatch")
                    );
                  return Promise.resolve();
                },
              },
            ]}
          >
            <Input
              placeholder={t("systems.Placeholder.pleaseInputAgain", {
                field: t("domains.Setting.changePassword"),
              })}
            />
          </Form.Item>
        </Form.Item>

        <div className="flex jc:end">
          <Button type="primary" htmlType="submit">
            {t("systems.Action.submit")}
          </Button>
        </div>
      </Form>
    </div>
  );
};
